export default __webpack_public_path__ + "static/media/Globe Life Dark.56c62493.svg";